import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { Text } from 'react-native';
import { PosterStudioView } from './PosterStudioView';

/** 朋友圈海报, opened from 知车 AI's home: the poster studio over the tabs. */
export const PosterStudioPage = wrapNavigatorScreen(
  () => {
    const profile = useUserProfileInfo();
    const navigation = useAppNavigation();
    if (!profile) return null;
    if (!profile.user.enabled) return <Text>当前账号不可用，请重新登录。</Text>;
    return (
      // A store switch is a new session: the studio signs in as the store.
      <PosterStudioView
        key={`${profile.org.id}:${profile.store.id}:${profile.user.userId}`}
        orgId={profile.org.id}
        storeId={profile.store.id}
        onLeave={() => navigation.goBack()}
      />
    );
  },
  // On web a stack card that fills the window lets the document scroll.
  { title: '朋友圈海报', headerShown: false, headerMode: 'float' },
);
